<template>
    <div>
        <h1>Playlist Sorts</h1>
        <v-layout>
            <v-text-field v-model="value" solo label="Name"></v-text-field>
            <v-btn :disabled="(value!=null&&value!='')?false:true" @click="createGoal" text color="success">add new Sort</v-btn>
        </v-layout>
        <v-layout>
            <v-text-field @input="seatchMethod" v-model="search" solo label="Search"></v-text-field>
        </v-layout>
        <v-layout v-if="sorts != null">
            <v-data-table
      v-if="sorts.length"
      :headers="[
        { text: 'ID', value: 'id' },
        { text: 'VALUE', value: 'value' },
        { text: 'INDEX_ORDER', value: 'index_order' },
        { text: 'EDIT', value: 'edit' },
        { text: 'DELETE', value: 'actions' },
        
      ]"
      :items="filteredSorts"
    >
    <template v-slot:item.actions="{ item }">
    <v-btn @click="deleteItem(item)" text color="error">DELETE</v-btn>
    </template>
    <template v-slot:item.edit="{ item }">
    <v-btn @click="edit(item)" text color="info">Edit</v-btn>
    </template>
    </v-data-table>
    <v-dialog
        v-model="dialog"
        v-if="selected!=null"
        width="500"
    >
      <v-card>
        <v-card-title
            class="headline grey lighten-2"
            primary-title
        >
          Updating
        </v-card-title>

        <v-card-text>
          <v-text-field v-model="selected.value" label="Value"></v-text-field>
        </v-card-text>
        <v-card-text>
          <v-text-field v-model="selected.index_order" label="Index order"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field v-model="selected.translation[3].data.sec_1" label="Value Ar"></v-text-field>
        </v-card-text>
        <v-card-text>
          <v-text-field v-model="selected.translation[1].data.sec_1" label="Value Eng"></v-text-field>
        </v-card-text>
        <v-card-text>
          <v-text-field v-model="selected.translation[2].data.sec_1" label="Value Ru"></v-text-field>
        </v-card-text>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="success"
              flat
              @click="update"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        </v-layout>
    </div>
</template>
<script>
import Axios from 'axios';

export default {
    data() {
        return {
            value: null,
            sorts: null,
            filteredSorts: null,
            search: '',
            selected: null,
            dialog:false,
        }
    },
    methods: {
        async update()
        {
            if(this.selected.value !=null && this.selected.value != "")
            this.selected.translation[0].data.sec_1 = this.selected.value;
            await axios
                .post("/playlist-sorts/update", {
                    id: this.selected.id,
                    value: this.selected.value,
                    index_order: this.selected.index_order,
                    translation: this.selected.translation
                }).then(()=>{
                    this.sync();
                    this.dialog = false;
                })
        },
        edit(item)
        {
            this.selected = Object.assign({}, item);
            this.dialog = true;
        },
        seatchMethod(val)
        {
            if(this.search=='')
            {
                this.filteredSorts = this.sorts.sort((a, b) => {
      const orderA = a.index_order;
      const orderB = b.index_order;

      // Если orderA или orderB равны 0, перемещаем их в конец
      if (orderA === 0 && orderB !== 0) {
        return 1; // orderA идет после orderB
      }
      if (orderB === 0 && orderA !== 0) {
        return -1; // orderB идет после orderA
      }

      // Обычная сортировка
      return orderA - orderB;
    });
            }
            else
            {
                this.filteredSorts = this.sorts.filter(element => {
                return (element.value).includes(this.search)});
            }
        },
        async createGoal() {
            if(this.value !=null && this.value != "")
            await axios
                .post("/playlist-sorts/create", {
                    value: this.value
                }).then(()=>{
                    this.sync();
                    this.value = null;
                })
        },
        async deleteItem(item) {
            await axios
                .post("/playlist-sorts/delete", item).then(()=>{
                    this.sync();
                })
        },
        async sync() {
            await axios
                .get("/playlist-sorts/index").then((res)=>{
                    this.sorts = res.data.sort((a, b) => {
      const orderA = a.index_order;
      const orderB = b.index_order;

      // Если orderA или orderB равны 0, перемещаем их в конец
      if (orderA === 0 && orderB !== 0) {
        return 1; // orderA идет после orderB
      }
      if (orderB === 0 && orderA !== 0) {
        return -1; // orderB идет после orderA
      }

      // Обычная сортировка
      return orderA - orderB;
    });

                    this.filteredSorts = res.data.sort((a, b) => {
      const orderA = a.index_order;
      const orderB = b.index_order;

      // Если orderA или orderB равны 0, перемещаем их в конец
      if (orderA === 0 && orderB !== 0) {
        return 1; // orderA идет после orderB
      }
      if (orderB === 0 && orderA !== 0) {
        return -1; // orderB идет после orderA
      }

      // Обычная сортировка
      return orderA - orderB;
    });
                })
        },
    },
    created() {
        this.sync();
    }
}
</script>
<style lang="scss" scoped></style>